import api from "../api/axios";

// Hours logged for an employee within a month, as `{ entries, total_hours }`.
export const getEmployeeHours = async (employeeId, month) => {
  try {
    const response = await api.get(`/api/employee-hours/${employeeId}`, {
      params: { month },
    });
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};

// Upsert hours for one employee on one date -- re-saving a date updates it.
export const saveEmployeeHours = async (payload) => {
  try {
    const response = await api.post(`/api/employee-hours`, payload);
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};

export const deleteEmployeeHours = async (id) => {
  try {
    const response = await api.delete(`/api/employee-hours/${id}`);
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};
